import * as tslib_1 from "tslib";
import { EVENTS, Router as StdRouter } from "../Router";
import { Children, Component, createElement, PropTypes } from "react";
import { convertReactComponentRoutesToStandardRoutes } from "./convertReactComponentRoutesToStandardRoutes";
export class Router extends Component {
    /**
     * @param props
     */
    constructor(props) {
        super(props);
        /**
         * @type {{component: any}}
         */
        this.state = {
            components: [],
            params: {},
            query: {},
            middlewareResult: null,
        };
        if (!props.router) {
            throw new Error("You must provide the Router via props");
        }
        props.router.subscribe(EVENTS.ROUTE_MATCHED, (matchedRoute, data) => {
            let components = [];
            let route = matchedRoute;
            while (route) {
                const component = route.callback();
                if (component) {
                    components.push(route.callback());
                }
                route = route.parent;
            }
            this.setState(tslib_1.__assign({ components }, data));
        });
    }
    /**
     * @return {{router: Router}}
     */
    getChildContext() {
        return { router: this.props.router };
    }
    render() {
        if (this.state.components.length === 0) {
            return null;
        }
        let components = this.state.components.slice(0);
        let component;
        while (components.length > 0) {
            component = createElement(components.shift(), {
                params: this.state.params,
                query: this.state.query,
                resolve: this.state.middlewareResult,
            }, component);
        }
        return component;
    }
    componentDidMount() {
        if (this.props.children) {
            this.props.router.add(convertReactComponentRoutesToStandardRoutes(Children.only(this.props.children)));
        }
        this.props.router.start();
    }
    componentWillUnmount() {
        // this.props.router.stop();
    }
}
/**
 * @type {{router: React.Requireable<any>}}
 */
Router.childContextTypes = {
    router: PropTypes.instanceOf(StdRouter)
};
